module.exports = __webpack_public_path__ + "img/telecomCourse.348552df.png";